import React, { useEffect, useState } from 'react';
import './form.scss';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { height } from '@mui/system';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import useLocalizedNavigate from "../../hooks/useLocalizedNavigate";
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import googlePlayBadge from '../../assets/images/google-store-button.png';
import appStoreBadge from '../../assets/images/ios-store-button.png';
import qrAndroid from '../../assets/images/qr-android.png';
import qrIos from '../../assets/images/qr-ios.png';

const ApplicationForm = () => {
    const { t } = useTranslation();

    const [checked, setChecked] = React.useState(true);
    const [data, setData] = React.useState({});

    const [validated, setValidated] = useState(false);
    const [valueVehicle, setValueVehicle] = React.useState('No');
    const [valueWork, setValueWork] = React.useState('No');
    const [valueCouple, setValueCouple] = React.useState('No');
    const [valueKid, setValueKid] = React.useState('No');
    const [valueHelp, setValueHelp] = React.useState('No');
    const [valueEnableButton, setValueEnableButton] = React.useState(true);

    //WorkPerson
    const [valueWifeWorks, setValueWifeWorks] = React.useState('No');
    const [valueHusbandWorks, setValueHusbandWorks] = React.useState('No');
    const [valueOtherPersonWorks1, setValueOtherPersonWorks1] = React.useState('No');
    const [valueOtherPersonWorks2, setValueOtherPersonWorks2] = React.useState('No');
    const [valueOtherPersonWorks3, setValueOtherPersonWorks3] = React.useState('No');
    const [valueOtherPersonWorks4, setValueOtherPersonWorks4] = React.useState('No');

    //HelpHandler
    const [valueJob, setValueJob] = React.useState('No');
    const [valueFood, setValueFood] = React.useState('No');
    const [valueInmigration, setValueInmigration] = React.useState('No');
    const [valueMedical, setValueMedical] = React.useState('No');
    const [valueOthers, setValueOthers] = React.useState('No');


    const [state, setState] = React.useState([]);
    const [stateSelected, setStateSelected] = React.useState(null);
    const [cities, setCities] = React.useState([]);
    const [citySelected, setCitySelected] = React.useState(null);
    const [zipCodes, setZipCodes] = React.useState([]);
    const [zipCodeSelected, setZipCodeSelected] = React.useState(null);
    const [modalTitle, setModalTitle] = React.useState('');
    const [modalMessage, setModalMessage] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const [isDisabledCouple, setIsDisabledCouple] = useState(true);
    const [isDisabledAge, setIsDisabledAge] = useState(true);

    const [isDisabledKidName, setIsDisabledKidName] = useState(true);
    const [isDisabledKidNumber, setIsDisabledKidNumber] = useState(true);

    const [MaritalStatus, setMaritalStatus] = React.useState('');

    const [isDisabledWifeSalary, setIsDisabledWifeSalary] = useState(true);
    const [isDisabledHusbandSalary, setIsDisabledHusbandSalary] = useState(true);
    const [isDisabledOtherSalary1, setIsDisabledOtherSalary1] = useState(true);
    const [isDisabledOtherSalary2, setIsDisabledOtherSalary2] = useState(true);
    const [isDisabledOtherSalary3, setIsDisabledOtherSalary3] = useState(true);
    const [isDisabledOtherSalary4, setIsDisabledOtherSalary4] = useState(true);

    const [isDisabledSpentRentMortgage, setIsDisabledSpentRentMortgage] = useState(true);
    const [isDisabledSpentFood, setIsDisabledSpentFood] = useState(true);
    const [isDisabledSpentElectricity, setIsDisabledSpentElectricity] = useState(true);
    const [isDisabledSpentWater, setIsDisabledSpentWater] = useState(true);
    const [isDisabledSpentPhone, setIsDisabledSpentPhone] = useState(true);
    const [isDisabledSpentInternet, setIsDisabledSpentInternet] = useState(true);
    const [isDisabledSpentTransportation, setIsDisabledSpentTransportation] = useState(true);
    const [isDisabledSpentInsurance, setIsDisabledSpentInsurance] = useState(true);
    const [isDisabledSpentOtherExpenses, setIsDisabledSpentOtherExpenses] = useState(true);
    const [errorCheck, setErrorCheck] = React.useState(false);

    const [values, setValues] = useState({ SpentRentMortgage: "0", SpentFood: "0", SpentElectricity: "0", sum: "" })
    const [SpentRentMortgage, setSpentRentMortgage] = useState('0')
    const [SpentFood, setSpentFood] = useState('0')
    const [SpentElectricity, setSpentElectricity] = useState('0')
    const [SpentWater, setSpentWater] = useState('0')
    const [SpentPhone, setSpentPhone] = useState('0')
    const [SpentInternet, setSpentInternet] = useState('0')
    const [SpentTransportation, setSpentTransportation] = useState('0')
    const [SpentInsurance, setSpentInsurance] = useState('0')
    const [SpentOtherExpenses, setOtherExpenses] = useState('0')


    const [sum, setSum] = useState('')

    const handleChangeMarital = (event) => {
        setMaritalStatus(event.target.value);
    };


    const navigate = useLocalizedNavigate();
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const [age, setAge] = React.useState('');

    const handleChangeS = (event) => {
        setAge(event.target.value);
    };

    const submitFormData = (event) => {
        const form = event.currentTarget;
        console.log('form', form.checkValidity());
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setModalTitle(t('appForm.reviewInfo'))
            setModalMessage(t('appForm.fieldsIncorrect'))
            setErrorCheck(true);
            handleClickOpen();
            setValidated(true);
        } else {
            event.preventDefault();
            const data = {}
            for (let i = 0; i < event.target.length; i++) {
                if (event.target[i].name != "" && event.target[i].value != "") {
                    data[event.target[i].name] = event.target[i].value;
                }
                // { [atribute]: event.target.value }
            }
            data.HaveVehicle = valueVehicle;
            data.HaveWorkPermition = valueWork;
            data.ShareHomeWCouple = valueCouple;
            data.LiveWDependentSons = valueKid;
            data.OtherAdltsHelpWSpends = valueHelp;
            console.log("atributes", data);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                "Email": data.Email,
                "PhoneNumber": data.PhoneNumber,
                "Password": data.Password,
                "Name": data.Name,
                "LastName": data.LastName,
                "Age": data.Age,
                "MaritalStatus": data.MaritalStatus,
                "LiveAlone": data.LiveAlone,
                "ShareHomeWCouple": data.ShareHomeWCouple,
                "CoupleName": data.CoupleName,
                "CoupleAge": data.CoupleAge,
                "OtherAdultsNames": data.OtherAdultsNames,
                "OtherAdultAges": data.OtherAdultAges,
                "LiveWDependentSons": data.LiveWDependentSons,
                "DependentSonsNumbr": data.DependentSonsNumbr,
                "DependentSonsNames": data.DependentSonsNames,
                "WifeWorks": data.WifeWorks,
                "WifeSalary": data.WifeSalary,
                "HusbandWorks": data.HusbandWorks,
                "HusbandSalary": data.HusbandSalary,
                "OtherPersonWorks1": data.OtherPersonWorks1,
                "OtherPersonSalary1": data.OtherPersonSalary1,
                "OtherPersonWorks2": data.OtherPersonWorks2,
                "OtherPersonSalary2": data.OtherPersonSalary2,
                "OtherPersonWorks3": data.OtherPersonWorks3,
                "OtherPersonSalary3": data.OtherPersonSalary3,
                "OtherPersonWorks4": data.OtherPersonWorks4,
                "OtherPersonSalary4": data.OtherPersonSalary4,
                "OtherAdltsHelpWSpends": data.OtherAdltsHelpWSpends,
                "SpentRentMortgage": data.SpentRentMortgage,
                "SpentFood": data.SpentFood,
                "SpentElectricity": data.SpentElectricity,
                "SpentWater": data.SpentWater,
                "SpentPhone": data.SpentPhone,
                "SpentTransportation": data.SpentTransportation,
                "SpentInternet": data.SpentInternet,
                "SpentInsurance": data.SpentInsurance,
                "SpentOtherExpenses": data.SpentOtherExpenses,
                "HaveVehicle": data.HaveVehicle,
                "HaveWorkPermition": data.HaveWorkPermition,
                "ProfessionSkills": data.ProfessionSkills,
                "Need_job": data.Need_job,
                "Need_food": data.Need_food,
                "Need_immigration": data.Need_immigration,
                "Need_medical": data.Need_medical,
                "Need_legal": data.Need_legal,
                "Need_others": data.Need_others,
                "Need_others_explain": data.Need_others_explain,
                "History": data.History,
                "Warning1": "Yes",
                "Warning2": "Yes",
                "PhisicalAddresses.Zipcode": data.zipCode,
                "PhisicalAddresses.Street": data.street,
                "PhisicalAddresses.City": data.city,
                "PhisicalAddresses.State": data.state,


            });
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://tc.svdpguadalupe.org/svdp/Hauseholdheads?webmode=yes", requestOptions)

                // .then(response => response.json())
                // .then(result => console.log(result))
                // .catch(error => console.log('error', error));
                .then(response => response.json())
                .then(result => {
                    console.log('result', result);
                    if (result.success == true) {
                        setModalTitle('')
                        setModalMessage(t('appForm.confirmEmail'))
                        setErrorCheck(false);
                        handleClickOpen();
                    } else {
                        setModalTitle(t('appForm.errorTitle'))
                        setModalMessage(t('appForm.errorInternal'))
                        setErrorCheck(true);
                        handleClickOpen();
                    }
                })
                .catch(error => {
                    console.log('error post', error)
                    setModalTitle(t('appForm.errorTitle'))
                    setModalMessage(t('appForm.errorRegistration'))
                    setErrorCheck(true);
                    handleClickOpen();
                });
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (errorCheck === false) {
            navigate("/");
        }
    };

    const handleRadioVehicle = (event) => {
        setValueVehicle(event.target.value);
    };

    const handleRadioWork = (event) => {
        console.log(event.target.value)
        setValueWork(event.target.value);
    };

    const handleRadioCouple = (event) => {
        setValueCouple(event.target.value);
        if (event.target.value == 'No') {
            setIsDisabledCouple(true)
            setIsDisabledAge(true)
        } else {
            setIsDisabledCouple(false)
            setIsDisabledAge(false)
        }
    };

    const handleRadioKid = (event) => {
        setValueKid(event.target.value);
        if (event.target.value == 'No') {
            setIsDisabledKidName(true)
            setIsDisabledKidNumber(true)
        } else {
            setIsDisabledKidName(false)
            setIsDisabledKidNumber(false)
        }
    };
    const handleRadioHelp = (event) => {
        setValueHelp(event.target.value);
    };

    const getState = () => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch("https://tc.svdpguadalupe.org/svdp/Get_US_states", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success == true) {
                    setState(result.data)
                } else {
                    setModalTitle(t('appForm.errorTitle'))
                    setModalMessage(t('appForm.errorInternal'))
                    handleClickOpen();
                }

            })
            .catch(error => console.log('error', error));
    }

    const getStateValue = (event) => {
        if (event.target.value != null || event.target.value != undefined) {
            setStateSelected(event.target.value);
            setCitySelected('');
            setCities([]);
            setZipCodes([]);
            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };

            fetch(`https://tc.svdpguadalupe.org/svdp/Get_US_cities_by_state?state=${event.target.value}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.success == true) {
                        setCities(result.data)
                    } else {
                        setModalTitle(t('appForm.errorTitle'))
                        setModalMessage(t('appForm.errorInternal'))
                        handleClickOpen();
                    }
                })
                .catch(error => console.log('error', error));
        }
        console.log('city', citySelected)

    }

    const getCityValue = (event) => {
        if (event.target.value != null || event.target.value != undefined) {
            setCitySelected(event.target.value);
            var requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
            fetch(`https://tc.svdpguadalupe.org/svdp/Get_US_zipCodes_by_state_city?state=${stateSelected}&city=${event.target.value}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.success == true) {
                        setZipCodes(result.data)
                    } else {
                        setModalTitle(t('appForm.errorTitle'))
                        setModalMessage(t('appForm.errorInternal'))
                        handleClickOpen();
                    }
                })
                .catch(error => console.log('error', error));
        }

    }

    const getZipcodeValue = (event) => {
        setZipCodeSelected(event.target.value);
        console.log('zipCode', event.target.value)
    }

    const handleCheckWife = (event) => {

        if (event.target.checked == true) {
            setIsDisabledWifeSalary(false)
            setValueWifeWorks('Yes')
        } else {
            setIsDisabledWifeSalary(true)
            setValueWifeWorks('No')
        }

    }
    const handleCheckHusband = (event) => {
        if (event.target.checked == true) {
            setIsDisabledHusbandSalary(false)
            setValueHusbandWorks('Yes')
        } else {
            setIsDisabledHusbandSalary(true)
            setValueHusbandWorks('No')
        }
    }
    const handleCheckOther1 = (event) => {
        if (event.target.checked == true) {
            setIsDisabledOtherSalary1(false)
            setValueOtherPersonWorks1('Yes')
        } else {
            setIsDisabledOtherSalary1(true)
            setValueOtherPersonWorks1('No')
        }
    }
    const handleCheckOther2 = (event) => {
        if (event.target.checked == true) {
            setIsDisabledOtherSalary2(false)
            setValueOtherPersonWorks2('Yes')
        } else {
            setIsDisabledOtherSalary2(true)
            setValueOtherPersonWorks2('No')
        }
    }
    const handleCheckOther3 = (event) => {
        if (event.target.checked == true) {
            setIsDisabledOtherSalary3(false)
            setValueOtherPersonWorks3('Yes')
        } else {
            setIsDisabledOtherSalary3(true)
            setValueOtherPersonWorks3('No')
        }
    }
    const handleCheckOther4 = (event) => {
        if (event.target.checked == true) {
            setIsDisabledOtherSalary4(false)
            setValueOtherPersonWorks4('Yes')
        } else {
            setIsDisabledOtherSalary4(true)
            setValueOtherPersonWorks4('No')
        }
    }

    const handleSpentRentMortgage = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentRentMortgage(false)
        } else {
            setIsDisabledSpentRentMortgage(true)
        }
    }

    const handleSpentFood = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentFood(false)
        } else {
            setIsDisabledSpentFood(true)
        }
    }

    const handleSpentElectricity = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentElectricity(false)
        } else {
            setIsDisabledSpentElectricity(true)
        }
    }

    const handleSpentWater = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentWater(false)
        } else {
            setIsDisabledSpentWater(true)
        }
    }

    const handleSpentPhone = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentPhone(false)
        } else {
            setIsDisabledSpentPhone(true)
        }
    }

    const handleSpentInternet = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentInternet(false)
        } else {
            setIsDisabledSpentInternet(true)
        }
    }

    const handleSpentTransportation = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentTransportation(false)
        } else {
            setIsDisabledSpentTransportation(true)
        }
    }

    const handleSpentInsurance = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentInsurance(false)
        } else {
            setIsDisabledSpentInsurance(true)
        }
    }

    const handleSpentOtherExpenses = (event) => {
        if (event.target.checked == true) {
            setIsDisabledSpentOtherExpenses(false)
        } else {
            setIsDisabledSpentOtherExpenses(true)
        }
    }

    const onChangeSum = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const newValues = {
            ...values,
            [name]: value
        }
        setValues(newValues)
        calcSum(newValues)
        calcfirst(newValues)
        calcSecond(newValues)


    }
    const calcSum = (newValues) => {
        const { SpentRentMortgage, SpentFood } = newValues;
        const newSum = parseInt(SpentRentMortgage, 10) + parseInt(SpentFood, 10)
        setSum(newSum)
    }
    const calcfirst = (newValues) => {
        const { sum, SpentFood } = newValues;
        const newSpentRentMortgage = parseInt(sum, 10) - parseInt(SpentFood, 10)
        setSpentRentMortgage(newSpentRentMortgage)
    }
    const calcSecond = (newValues) => {
        const { sum, SpentRentMortgage } = newValues;
        const newSpentFood = parseInt(sum, 10) - parseInt(SpentRentMortgage, 10)
        setSpentFood(newSpentFood)
    }

    //HelpHandler
    const handleCheckJob = (event) => {
        if (event.target.checked == true) {
            setValueJob('Yes')
        }
    }
    const handleCheckFood = (event) => {
        if (event.target.checked == true) {
            setValueFood('Yes')
        }
    }
    const handleCheckInmigration = (event) => {
        if (event.target.checked == true) {
            setValueInmigration('Yes')
        }
    }
    const handleCheckMedical = (event) => {
        if (event.target.checked == true) {
            setValueMedical('Yes')
        }
    }
    const handleCheckOthers = (event) => {
        if (event.target.checked == true) {
            setValueOthers('Yes')
        }
    }

    const handleWarningButton1 = (event) => {
        if (event.target.checked == true) {
            setValueEnableButton(false)
        }

    }

    useEffect(() => {
        getState();
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-12">
                    <h1 className="display-4 text-center" style={{ fontSize: '4rem', marginTop: '25px', marginBottom: '0' }}>{t('appForm.needHelp')}</h1>
                </div>
            </div>
            
            <div className="row justify-content-center mb-5">
                <div className="col-12">
                    <h2 className="text-center" style={{ fontSize: '2.5rem' }}>{t('appForm.downloadApp')}</h2>
                </div>
            </div>
            
            <div className="row justify-content-center">
                <div className="col-md-5 text-center mb-5">
                    <h3 className="mb-4">{t('appForm.androidApp')}</h3>
                    <img 
                        src={qrAndroid}
                        alt="QR Android"
                        style={{ width: '200px', height: '200px', marginBottom: '20px', display: 'block', margin: '0 auto 20px' }}
                    />
                    <div>
                        <a 
                            href="https://play.google.com/store/apps/details?id=com.svdpapp&hl=en" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ display: 'block' }}
                        >
                            <img 
                                src={googlePlayBadge}
                                alt="Google Play Store"
                                style={{ width: '240px', height: 'auto' }}
                            />
                        </a>
                    </div>
                </div>
                <div className="col-md-5 text-center mb-5">
                    <h3 className="mb-4">{t('appForm.iosApp')}</h3>
                    <img 
                        src={qrIos}
                        alt="QR iOS"
                        style={{ width: '200px', height: '200px', marginBottom: '20px', display: 'block', margin: '0 auto 20px' }}
                    />
                    <div>
                        <a 
                            href="https://apps.apple.com/us/app/svdpapp/id6479328863" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ display: 'block' }}
                        >
                            <img 
                                src={appStoreBadge}
                                alt="App Store"
                                style={{ width: '240px', height: 'auto' }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApplicationForm;

